import http from '@/http-common'
import Title from '@/components/TitlePage.vue';

export default {
  name: 'NormPage',
  components: {Title},
  data() {
    return {
      items: [],
      captionPage: 'Постановление Правительства Республики Бурятия № 319 от 31.12.2009 г.',
      columns: [
        {key: 'nameCost', label: 'Статья расхода', sortable: true, tdClass: 'normaClass300'},
      ],
      columns2: [
        {key: 'nameCost', label: 'Статья расхода', sortable: true, tdClass: 'normaClass300'},
      ],
      columnsDet: [
        {key: 'nameKind', label: 'Статус мероприятия'},
        {key: 'norma', label: 'Норма (руб.)', tdClass: 'normaClass'},
        {key: 'comment', label: 'Комментарий'},
      ],
      filter: null,
      filter2: null,
      selectMode: 'single',
      selected: [],
      eventkindList: [],
      editItem: {event_normList: []},
      modalEditOpened: false,
      costs: [],
      events: [],
      aCodes: [],
      analyticCode: 0
    }
  },
  created() {
    this.loadCodes();
    this.loadEventKind();
  },
  methods: {
    loadEventKind() {
      var vm = this;
      http.get('/eventkind/list')
      .then((response) => {
        vm.eventkindList = response.data;
        vm.eventkindList.forEach(function (x) {
          var col = {
            key: 'event.event_' + x.id,
            label: x.nameKind,
            tdClass: 'normaClass'
          }
          vm.columns.push(col);
          vm.columns2.push(col);
          //vm.loadNorm();
        })
        var colEdit = {key: 'edit_field', label: ''}
        vm.columns.push(colEdit);
        vm.columns2.push(colEdit);
      })
      .catch((error) => console.log(error.message));
    },
    loadNorm() {
      var vm = this;
      http.get('/norm/table/cost?code=' + this.analyticCode)
      .then((response) => {
        vm.items = response.data;
        vm.items.forEach(function (item) {
          item._showDetails = false;
          item.event = {};
          item.event_normList.forEach(function (ev) {
            item.event['event_' + ev.eventKindId] = ev.norma.toFixed(2) + ' руб';
          })
          if (item.childs.length > 0) {
            item.childs.forEach(function (child) {
              child.event = {};
              child.event_normList.forEach(function (ev) {
                child.event['event_' + ev.eventKindId] = ev.norma.toFixed(2) + ' руб';
              })
            })
            vm.summChild(item)
          }
        })
      })
      .catch((error) => console.log(error.message));
    },
    loadCosts() {
      var vm = this;
      http.get('/cost/list')
      .then((response) => {
        vm.costs = response.data;
        vm.costs.forEach(function (x) {
          x.value = x.id;
          x.text = x.nameCost;
        })
      })
      .catch((error) => console.log(error.message));
    },
    loadCodes() {
      var vm = this;
      http.get('/cost/analytic/list')
      .then((response) => {
        vm.aCodes = response.data;
        vm.aCodes.forEach(function (x) {
          x.value = x.id;
          x.text = x.code + '-' + x.statiya;
        })
        if (vm.aCodes.length > 0) {
          vm.analyticCode = vm.aCodes[0].id;
          this.loadNorm()
        }
      })
      .catch((error) => console.log(error.message));
    },
    loadEvents(rec) {
      var vm = this;
      http.get('/eventkind/list')
      .then((response) => {
        vm.events = response.data;
        vm.events.forEach(function (x) {
          rec.event_normList.forEach(function (item) {
            if (item.eventKindId === x.id) {
              x.norm_id = item.id;
              x.norma = item.norma;
              x.comment = item.comment;
            }
          })
        })
      })
      .catch((error) => console.log(error.message));
    },
    showDetails(rec) {
      if (rec.childs.length > 0) {
        rec._showDetails = !rec._showDetails;
      }
    },
    showEdit(rec) {
      if (!rec.childs || rec.childs.length === 0) {
        this.editItem = JSON.parse(JSON.stringify(rec));
        this.loadCosts();
        this.loadEvents(rec);
        this.modalEditOpened = !this.modalEditOpened;
      }
    },
    saveNorm() {
      var vm = this;
      this.editItem.event_normList = [];
      this.events.forEach(function (x) {
        var evnt = {id: x.norm_id, eventKindId: x.id, norma: x.norma, comment: x.comment};
        vm.editItem.event_normList.push(evnt);
      })
      http.post('norm', this.editItem)
      .then((response) => {
        if (response.data) {
          var index = -1;
          if (response.data.parent_id && response.data.parent_id > 0) {
            index = vm.items.map(e => e.cost_id).indexOf(response.data.parent_id);
          } else {
            index = vm.items.map(e => e.cost_id).indexOf(response.data.cost_id);
          }
          if (index >= 0) {
            if (response.data.parent_id && response.data.parent_id > 0) {
              const index2 = vm.items[index].childs.map(e => e.cost_id).indexOf(response.data.cost_id);
              if (index2 >= 0) {
                vm.items[index].childs[index2] = JSON.parse(JSON.stringify(response.data));
                vm.items[index].childs[index2].event = {};
                response.data.event_normList.forEach(function (ev) {
                  vm.items[index].childs[index2].event['event_' + ev.eventKindId] = ev.norma.toFixed(2) + ' руб';
                });
                vm.summChild(vm.items[index]);
              }
            } else {
              vm.items[index] = JSON.parse(JSON.stringify(response.data));
              vm.items[index].event = {};
              response.data.event_normList.forEach(function (ev) {
                vm.items[index].event['event_' + ev.eventKindId] = ev.norma.toFixed(2) + ' руб';
              });
            }
          }
          vm.modalEditOpened = !vm.modalEditOpened;
        } else {
          alert('Ошибка сохранения данных!')
        }
      })
      .catch((error) => console.log(error.message));
    },
    summChild(rec) {
      var summ = {};
      for (var key in rec.event) {
        rec.event[key] = '';
        summ[key] = 0;
      }
      rec.childs.forEach(function (child) {
        child.event_normList.forEach(function (ev) {
          //child.event['event_'+ev.eventKindId] = ev.norma.toFixed(2) + ' руб';
          summ['event_' + ev.eventKindId] = (summ['event_' + ev.eventKindId] ? summ['event_' + ev.eventKindId] : 0) +
              parseFloat(ev.norma);
        });
      });
      for (var key in summ) {
        rec.event[key] = summ[key].toFixed(2) + ' руб';
      }
    },
    iconVal(row) {
      if (row.item.childs.length > 0) {
        if (row.detailsShowing) {
          return 'minus';
        } else {
          return 'plus';
        }
      } else {
        return 'edit-2'
      }
    },
    titleVal(row) {
      if (row.item.childs.length > 0) {
        if (row.detailsShowing) {
          return 'Скрыть подразделы';
        } else {
          return 'Показать подразделы';
        }
      } else {
        return 'Редактировать'
      }
    },
    showBtn(rec) {
      if (rec.childs.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    hasChilds: function (rec) {
      var flag = rec.childs.length > 0
      return flag;
    }
  }
}
